const storageKey = "pendingEmailValidation";

export const getPendingEmailValidation = () => {
  if (typeof window === "undefined" || !window.localStorage) {
    return false;
  }
  return window.localStorage.getItem(storageKey) === "true";
};

export const setPendingEmailValidation = (value) => {
  if (typeof window === "undefined" || !window.localStorage) {
    return;
  }
  window.localStorage.setItem(storageKey, value ? "true" : "false");
};
